import HabitatsUpdater from '@/components/HabitatsUpdater';
import Header from '@/components/Header';
import LiveChannelsBar from '@/components/LiveChannelsBar';
import PageWrapper from '@/components/Main/PageWrapper';
import PubNubWrapper from '@/components/PubNubWrapper';

import CommunityFeedCard from './CommunityFeedCard';
import HomeContent from './HomeContent';
import UpcomingEventsCard from './UpcomingEventsCard';

const Home = () => {
  return (
    <div className="relative grid h-full grid-cols-1 group-[]/fullscreen:block md:grid-cols-[64px_1fr_340px]">
      <aside className="relative z-[11] h-full group-[]/fullscreen:hidden max-md:hidden">
        <PubNubWrapper>
          <LiveChannelsBar />
        </PubNubWrapper>
      </aside>
      <main className="h-full overflow-y-auto pl-2">
        <HomeContent />
      </main>
      <aside className="h-full space-y-3 overflow-y-auto px-2 pb-4 shadow-md">
        <UpcomingEventsCard />
        <CommunityFeedCard />
      </aside>
    </div>
  );
};

const HomeWithLayout = () => {
  return (
    <>
      <Header />
      <PageWrapper>
        <Home />
      </PageWrapper>
      <HabitatsUpdater />
    </>
  );
};

export default HomeWithLayout;
